<template>
    <div class="tab_content">
        <span class="tab_content-title">{{ $t('editorTabImagesTitle') }}</span>
        <div class="tab_grid">
            <div class="gallery_grid">
                <div class="gallery_grid_item uploader">
                    <button
                        @click="addGalleryItem"
                    >
                        <inline-svg
                            :src="upload_icon"
                            fill="#737373"
                        />
                        <strong>{{ $t('editorTabImagesUpload') }}</strong>
                    </button>
                    <input type="file" name="file" id="galleryInput" multiple style="display: none;">
                </div>
                <div
                    v-for="image in gallery"
                    :key="image.id"
                    class="gallery_grid_item"
                    @click="addElement(image)"
                    @contextmenu.prevent="(e) => openMenu(e)"
                >
                    <div
                        :style="{ backgroundImage: `url(${image.thumbnailUrl})` }"
                        class="gallery_grid_item_img"
                    />
                    <button
                        class="gallery_grid_item-delete"
                        @click.stop="removeGalleryItem(image.id)"
                    >
                        <inline-svg
                            :src="remove_icon"
                            fill="white"
                        />
                    </button>
                    <div
                        class="contextMenu"
                        tabindex="-1"
                        @blur="(e) => closeMenu(e)"
                    >
                        <div @click.stop="setBackgroundUrl(image.url)">
                            {{ $t('editorTabImagesSetBackground') }}
                        </div>
                    </div>
                </div>
                <div v-if="loading" class="gallery_grid_item">
                    <div class="progress_bar">
                        <template v-if="processing">
                            <span>{{ $t('editorTabImagesProcessing') }}</span>
                        </template>
                        <template v-else>
                            <span>{{ progress }}</span>
                        </template>
                        <div class="progress_bar-track">
                            <div class="progress_bar-thumb" :style="`width: ${progress}`"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import axios from 'axios';
    import upload_icon from '@/assets/icons/panel_icons/upload.svg';
    import remove_icon from '@/assets/icons/panel_icons/trashcan.svg';
    import { uuid } from 'vue-uuid';
    import { RepositoryFactory } from '../../../repositories/repositoryFactory';
    const UploadRepository = RepositoryFactory.get('upload');

    export default {
        data() {
            return {
                remove_icon,
                upload_icon,
                gallery: [],
                uploadedImg: null,
                loading: false,
                progress: 0,
                processing: false,
                uploadedImages: [],
                files: [],
                uploadIds: []
            }
        },
        methods: {
            async addGalleryItem() {
                document.getElementById("galleryInput").click();

                console.log('multiple: ', document.getElementById("galleryInput").files)

                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.getSessionDetails.token
                }

                const that = this;
                let files = [];
                
                $('#galleryInput').fileupload({
                    url: `${this.getSessionDetails.backendUrl}/upload/chunk`,
                    maxChunkSize: 10000000, // 10MB
                    autoUpload: false,
                    headers: headers,
                    add: function (e, data) {
                        that.loading = true;

                        UploadRepository.add(JSON.stringify({filename: data.files[0].name}), headers)
                            .then((result) => {
                                data.formData = {upload_id: result.data.data.id};
                                data.submit();
                            })
                        
                    },
                    stop: function(e) {
                        console.log('uploads finished');

                        that.uploadIds.forEach(uploadId => {
                            UploadRepository.complete(uploadId, headers)
                            .then((result) => {
                                console.log('result: ', result)
                                if (!result.data.success) {
                                    that.progress = 'Error!';
                                }

                                function call() {
                                    return new Promise(function(resolve, reject) {
                                        (function get() {
                                            UploadRepository.listDetails(result.data.data.id, headers)
                                                .then((response) => {
                                                    if (response.data.data.status === 'processing') {
                                                        setTimeout(get, 4000);
                                                        that.processing = true;
                                                    }
                                                    if (response.data.data.status === 'completed') {
                                                        return resolve(response);                                                
                                                    }
                                                    
                                                })
                                            
                                        })();
                                    })
                                } 
                                call()
                                    .then(res => {
                                        that.gallery = [
                                            ...that.gallery,
                                            res.data.data
                                        ]

                                        that.uploadIds = [];
                                        that.loading = false;
                                        that.progress = 0 + '%';
                                        that.processing = false;  
                                    });                           
                            })
                            .finally(() => {
                                
                            })
                            .catch(err => {
                                console.log(err)
                            })
                        })


                    },
                    done: function (e, data) {
                        const uploadId = data.formData.upload_id;

                        that.uploadIds = [...that.uploadIds, data.formData.upload_id];
                    },
                    progressall: function (event, data) {
                        that.progress = Math.round((data.loaded / data.total) * 1000) / 10 + '%';
                    },
                    error: function(e, data) {
                        console.log(e)
                    }
                });
            },
            removeGalleryItem(imageId) {
                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.getSessionDetails.token
                }
                UploadRepository.deleteImg(imageId, headers)
                this.gallery = this.gallery.filter(item => item.id != imageId)
            },
            setImageSize(image) {
                const pageWidth = this.getPageWebSize.px.width;
                const pageHeight = this.getPageWebSize.px.height;
                let width, height;

                if (image.height !== null || image.width !== null) {
                    if (image.width > image.height) {
                        if (pageWidth < image.width) {
                            const ratio = image.width / image.height;
                            width = pageWidth - 100;
                            height = width / ratio;
                        } else {
                            width = image.width;
                            height = image.height;
                        }
                    }
                    if (image.height > image.width) {
                        if (pageHeight < image.height) {
                            const ratio = image.height / image.width;
                            height = pageHeight - 100;
                            width = height / ratio;
                        } else {
                            width = image.width;
                            height = image.height;
                        }
                    };
                } else {
                    width = 200;
                    height = 200;
                }
                

                const imageSize = {
                    width,
                    height
                }
                return imageSize;
            },
            async createImageElement(image) {
                const isSvg = image.mime.split(/[\/|+]/).includes('svg');
                const isPdf = image.mime === 'application/pdf' ? true : false;
                let newElement;

                let width, height;

                if (isSvg) {
                    let svgObject;
                    const that = this;

                    const svgResponse = await axios.get(image.url);
                    svgObject = svgResponse.data;

                    const svgElement = new DOMParser().parseFromString(svgObject, "text/xml").querySelectorAll('svg')[0];
                    const svgElementWidth = svgElement.getAttribute('width'); // check % width
                    const svgElementHeight = svgElement.getAttribute('height'); // check % height

                    String.prototype.isNumber = function(){return /^\d+$/.test(this);}

                    if (svgElementWidth !==  null && svgElementWidth.isNumber()) {
                        width = svgElementWidth;
                    } else {
                        if (svgElement.viewBox.baseVal.width !==  0) {
                            width = svgElement.viewBox.baseVal.width
                        } else {
                            width = 200;
                        }
                    }

                    if (svgElementHeight !== null && svgElementHeight.isNumber()) {
                        height = svgElementHeight;
                    } else {
                        if (svgElement.viewBox.baseVal.height !==  0) {
                            height = svgElement.viewBox.baseVal.height
                        } else {
                            height = 200;
                        }
                    }

                    newElement = {
                        id: uuid.v1(),
                        pageId: that.getActivePageId,
                        type: 'SHAPE_ELEMENT',
                        name: image.originalName,
                        path: image.url,
                        isOutline: false,
                        height: height,
                        width: width,
                        endValues: {
                            width: width,
                            height: height,
                        },
                        frame: {
                            translate: [0, 0],
                            scale: [1, 1],
                            rotate: 0
                        },
                        webSizeMM: {
                            width: width * 0.084667,
                            height: height * 0.084667,
                            translate: [0 * 0.084667, 0 * 0.084667]
                        },
                        isActive: true,
                        color: {
                            rgb: 'rgb(190, 186, 186)',
                            hex: 'BEBABA',
                            X: 4,
                            Y: 111
                        },
                        zIndex: that.getZIndex,
                        isLocked: false,
                        newTransforms: true
                    }    
                                   
                } else if (isPdf) {
                    width = this.setImageSize(image).width;
                    height = this.setImageSize(image).height;
                    const that = this;

                    newElement = {
                        id: uuid.v1(),
                        pageId: that.getActivePageId,
                        type: 'SHAPE_ELEMENT',
                        name: image.originalName,
                        path: image.svgUrl,
                        isOutline: false,
                        height: height,
                        width: width,
                        endValues: {
                            width: width,
                            height: height,
                        },
                        frame: {
                            translate: [0, 0],
                            scale: [1, 1],
                            rotate: 0
                        },
                        webSizeMM: {
                            width: width * 0.084667,
                            height: height * 0.084667,
                            translate: [0 * 0.084667, 0 * 0.084667]
                        },
                        isActive: true,
                        color: {
                            rgb: 'rgb(190, 186, 186)',
                            hex: 'BEBABA',
                            X: 4,
                            Y: 111
                        },
                        zIndex: that.getZIndex,
                        isLocked: false,
                        newTransforms: true
                    }
                } else {
                    width = this.setImageSize(image).width;
                    height = this.setImageSize(image).height;

                    newElement = {
                        // id: image.id,
                        id: uuid.v1(),
                        pageId: this.getActivePageId,
                        type: 'IMAGE_ELEMENT',
                        src: image.url,
                        isSvg,
                        width: width,
                        height: height,
                        endValues: {
                            width: width,
                            height: height,
                        },
                        webSizeMM: {
                            width: width * 0.084667,
                            height: height * 0.084667,
                            translate: [0 * 0.084667, 0 * 0.084667]
                        },
                        frame: {
                            translate: [0, 0],
                            scale: [1, 1],
                            rotate: 0
                        },
                        isActive: true,
                        filters: {
                            blur: {
                                value: 0
                            },
                            brightness: {
                                value: 100
                            },
                            contrast: {
                                value: 100
                            },
                            grayscale: {
                                value: 0
                            },
                            sepia: {
                                value: 0
                            }
                        },
                        zIndex: this.getZIndex,
                        isLocked: false,
                        newTransforms: true
                    }
                }

                if (this.getSessionDetails.mode === 'user') {
                    if (this.getActivePage.content.isLocked === false) {
                        this.$store.dispatch('ADD_PAGE_ELEMENT', newElement);
                    }
                } else {
                    this.$store.dispatch('ADD_PAGE_ELEMENT', newElement);
                }
            },
            activateEmptyPhotoCell(cell) {
                this.$store.dispatch('ACTIVATE_ELEMENT', cell)
                this.$store.dispatch('CHANGE_ACTIVE_ELEMENT', cell)
            },
            async addElement(image) {
                let width, height;
                const isSvg = image.mime.split(/[\/|+]/).includes('svg');
                const isPdf = image.mime === 'application/pdf' ? true : false;
                if (isSvg) {
                    let svgObject;
                    const that = this;

                    const svgResponse = await axios.get(image.url);
                    svgObject = svgResponse.data;

                    const svgElement = new DOMParser().parseFromString(svgObject, "text/xml").querySelectorAll('svg')[0];
                    const svgElementWidth = svgElement.getAttribute('width'); // check % width
                    const svgElementHeight = svgElement.getAttribute('height'); // check % height

                    String.prototype.isNumber = function(){return /^\d+$/.test(this);}

                    // let width, height;
                    if (svgElementWidth !==  null && svgElementWidth.isNumber()) {
                        width = svgElementWidth;
                    } else {
                        if (svgElement.viewBox.baseVal.width !==  0) {
                            width = svgElement.viewBox.baseVal.width
                        } else {
                            width = 200;
                        }
                    }

                    if (svgElementHeight !== null && svgElementHeight.isNumber()) {
                        height = svgElementHeight;
                    } else {
                        if (svgElement.viewBox.baseVal.height !==  0) {
                            height = svgElement.viewBox.baseVal.height
                        } else {
                            height = 200;
                        }
                    }
                } else if (isPdf) {
                    width = this.setImageSize(image).width;
                    height = this.setImageSize(image).height;
                } else {
                    width = this.setImageSize(image).width;
                    height = this.setImageSize(image).height;
                }

                if (Object.entries(this.getActiveElement).length > 0) {
                    if (this.getActiveElement.type === 'PHOTO_CELL_ELEMENT') {
                        if (this.getActiveElement.maskImg.src === null) {
                            let maskImg;

                            if (isSvg) {
                                maskImg = {
                                    src: image.url,
                                    width: width,
                                    height: height,
                                    isFromSvg: true,
                                    color: {
                                        rgb: 'rgb(190, 186, 186)',
                                        hex: 'BEBABA',
                                        X: 4,
                                        Y: 111
                                    }
                                }
                            } else if (isPdf) {
                                maskImg = {
                                    src: image.svgUrl,
                                    width: width,
                                    height: height,
                                    isFromSvg: true,
                                    color: {
                                        rgb: 'rgb(190, 186, 186)',
                                        hex: 'BEBABA',
                                        X: 4,
                                        Y: 111
                                    }
                                }
                            } else {
                                maskImg = {
                                    src: image.url,
                                    width: width,
                                    height: height,
                                    isFromSvg: false
                                }
                            }
                            this.$store.dispatch('UPDATE_ELEMENT', {
                                maskImg

                            })
                            if (this.getEmptyPhotoCells.length > 0) {
                                this.activateEmptyPhotoCell(this.getEmptyPhotoCells[0])
                            } 
                        } else {
                            let maskImg;
                            if (isSvg) {
                                maskImg = {
                                    src: image.url,
                                    width: width,
                                    height: height,
                                    isFromSvg: true,
                                    color: {
                                        rgb: 'rgb(190, 186, 186)',
                                        hex: 'BEBABA',
                                        X: 4,
                                        Y: 111
                                    }
                                }
                            } else if (isPdf) {
                                maskImg = {
                                    src: image.svgUrl,
                                    width: width,
                                    height: height,
                                    isFromSvg: true,
                                    color: {
                                        rgb: 'rgb(190, 186, 186)',
                                        hex: 'BEBABA',
                                        X: 4,
                                        Y: 111
                                    }
                                }
                            } else {
                                maskImg = {
                                    src: image.url,
                                    width: width,
                                    height: height,
                                    isFromSvg: false
                                }
                            }
                            this.$store.dispatch('UPDATE_ELEMENT', {
                                maskImg
                            })
                        }
                        
                    } else {
                        if (this.getEmptyPhotoCells.length > 0) {
                            this.activateEmptyPhotoCell(this.getEmptyPhotoCells[0]);

                            let maskImg;
                            if (isSvg) {
                                maskImg = {
                                    src: image.url,
                                    width: width,
                                    height: height,
                                    isFromSvg: true,
                                    color: {
                                        rgb: 'rgb(190, 186, 186)',
                                        hex: 'BEBABA',
                                        X: 4,
                                        Y: 111
                                    }
                                }
                            } else if (isPdf) {
                                maskImg = {
                                    src: image.svgUrl,
                                    width: width,
                                    height: height,
                                    isFromSvg: true,
                                    color: {
                                        rgb: 'rgb(190, 186, 186)',
                                        hex: 'BEBABA',
                                        X: 4,
                                        Y: 111
                                    }
                                }
                            } else {
                                maskImg = {
                                    src: image.url,
                                    width: width,
                                    height: height,
                                    isFromSvg: false
                                }
                            }
                            this.$store.dispatch('UPDATE_ELEMENT', {
                                maskImg
                            })
                        } else {
                            this.createImageElement(image);
                        }
                    }
                } else {
                    if (this.getEmptyPhotoCells.length > 0) {
                        this.activateEmptyPhotoCell(this.getEmptyPhotoCells[0])
                        const maskImg = {
                            src: image.url,
                            width: width,
                            height: height
                        }
                        this.$store.dispatch('UPDATE_ELEMENT', {
                            maskImg
                        })
                    } else {
                        this.createImageElement(image);
                    }
                }
            },
            openMenu(e) {
                if (this.getSessionDetails.mode === 'user') {
                    if (this.getActivePage.content.isLocked === false) {
                        this.showMenu(e);
                    }
                } else {
                    this.showMenu(e);
                }
            },
            showMenu(e) {
                e.currentTarget.classList.add('openContextMenu');
                const eventContextmenu = e.currentTarget.querySelectorAll('.contextMenu')[0];
                this.$nextTick(() => {
                    eventContextmenu.focus();
                });
                eventContextmenu.classList.add('opened');
                eventContextmenu.style.left = `${e.offsetX}px`;
                eventContextmenu.style.top = `${e.offsetY}px`;
            },
            closeMenu(e) {
                e.currentTarget.classList.remove('opened');
            },
            setBackgroundUrl(value) {
                this.$store.dispatch('SET_PAGE_BACKGROUND', {
                    ...this.getActivePage.content.backgroundImage,
                    url: value
                });
            }
        },
        computed: {
            ...mapState([
                'pages',
                'currentPageIndex'
            ]),
            ...mapGetters([
                'getEmptyPhotoCells',
                'getZIndex',
                'getActiveElement',
                'getActivePageId',
                'getPageWebSize',
                'getSessionDetails',
                'getActivePage',
                'getPages'
            ])
        },
        updated() {
            return this.$store.getters.getPages;
        },
        mounted() {
            const headers = {
                'api-key' : 'session',
                'api-sign' : this.getSessionDetails.token
            }
            UploadRepository.list(headers)
            .then((result) => {
                const entities = result.data.data.entities
                entities.forEach(entity => {
                    this.gallery = [
                        ...this.gallery,
                        entity
                    ]
                })
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .gallery_grid {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        margin-bottom: 5px;
    }
    .gallery_grid_item {
        width: 115px;
        height: 155px;
        margin: 8px 8px 8px 0;
        cursor: pointer;
        position: relative;
        border-radius: 3px;
    }
    .gallery_grid_item.uploader button {
        width: 100%;
        height: 100%;
        border: 1px solid #fff;
        background-color: #fff;
        border-radius: 8px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .gallery_grid_item-delete {
        opacity: 0;
        position: absolute;
        top: 5px;
        right: 5px;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border: 1px solid #6c497c;
        background-color: #6c497c;
        cursor: pointer;
        transition: opacity 0.3s ease;
    }
    .gallery_grid_item:hover .gallery_grid_item-delete {
        opacity: 1;
    }
    .gallery_grid_item_img {
        height: 100%;
        border-radius: 8px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .gallery_grid_item .progress_bar {
        border-radius: 8px;
        background-color: rgba(0, 0, 0, 0.3);
        height: 100%;
        width: 100%;
    }
    .progress_bar {
        display: flex;
        align-content: center;
        justify-content: center;
        flex-direction: column;
        padding: 10px;
        box-sizing: border-box;
    }
    .progress_bar > span {
        font-weight: 600;
        margin-bottom: 8px;
        text-align: center;
    }
    .progress_bar-track {
        border: 2px solid white;
        border-radius: 15px;
        width: 100%;
        height: 15px;
    }
    .progress_bar-thumb {
        background: white;
        border-radius: 15px;
        height: 100%;
    }
    @media (max-width: 1200px) {
        .gallery_grid_item {
            width: 80px;
            height: 120px;
        }
    }
    .contextMenu {
        display: none;

        &.opened {
            display: block;
            position: absolute;
            z-index: 1000;
            background-color: #f5f5f5;
            color: #737373;
            padding: 5px;
            border-radius: 5px;
        }

        > div:hover {
            color: #310048;
        }
    }    
</style>